import { Api } from "./api"
import { attributes } from "./attributes/sample-atribute";

export class SampleApi extends Api {
  constructor() {
    super('samples', attributes)
  }
}
